var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#0B0C10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.043 11.6684C20.6525 11.2779 20.0194 11.2779 19.6288 11.6684L13.2649 18.0324C12.8743 18.4229 12.8743 19.0561 13.2649 19.4466C13.6554 19.8371 14.2886 19.8371 14.6791 19.4466L20.3359 13.7898L25.9928 19.4466C26.3833 19.8371 27.0165 19.8371 27.407 19.4466C27.7975 19.0561 27.7975 18.4229 27.407 18.0324L21.043 11.6684ZM21.3359 30.2975V12.3755H19.3359V30.2975H21.3359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLink);
export default __webpack_public_path__ + "static/media/button-link.a75a0a104e3e3246b25040a79d814f76.svg";
export { ForwardRef as ReactComponent };